import styles from './GitLiveLogo.module.scss';

export const GitLiveLogo = () => (
  <h1 className={styles.logo}>
    <img src="/img/gitlive-logo.svg" />
    Git<strong>Live</strong>
  </h1>
);
